module.exports = __webpack_public_path__ + "img/mastercard.560aa05a.svg";